import { Reveal } from "@/components/shared/Reveal";
import { ArrowRight, Network } from "lucide-react";
import { openSignIn } from "@/lib/signInModal";
import { openPreRegister } from "@/lib/preRegisterModal";

export const BrokerHero = () => (
  <section className="pt-36 pb-20 bg-rr-navy relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-4xl mx-auto px-5 md:px-8 text-center relative">
      <Reveal>
        <div className="w-14 h-14 rounded-2xl bg-rr-orange/10 text-rr-orangeLight flex items-center justify-center mx-auto mb-5">
          <Network size={24} />
        </div>
        <div className="text-xs font-bold tracking-[0.22em] uppercase text-rr-orangeLight mb-4">RelayRigs for Brokers</div>
        <h1 data-testid="broker-hero-title" className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
          Build Your Driver Network.<br />Move More Freight.
        </h1>
        <p className="text-white/60 mt-5 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
          RelayRigs is building a network of commercial drivers that brokers can connect with, organize, and engage for transportation opportunities. Build your own private driver network, invite drivers you already work with, discover additional RelayRigs drivers, and send opportunities directly to selected drivers.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <button onClick={() => openSignIn("register", "broker")} data-testid="broker-hero-join-cta" className="inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-7 py-4 rounded-full hover:bg-white hover:text-rr-navy transition-all hover:-translate-y-1">
            Join as a Broker <ArrowRight size={18} />
          </button>
          <a href="#broker-driver-network" data-testid="broker-hero-build-network-cta" className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white font-bold px-7 py-4 rounded-full hover:bg-white/20 transition-all">
            Build Your Driver Network
          </a>
          <button onClick={() => openPreRegister("broker")} data-testid="broker-hero-preregister-cta" className="inline-flex items-center gap-2 text-white/70 font-bold px-4 py-4 hover:text-white transition-colors">
            Pre-Register Your Brokerage
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
